import ActionTypes from "../constants/ActionTypes";

const initialState = {
    isSuccess: false,
    hasError: false,
    isLoading: false,
    export: {}
};

export default (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ActionTypes.EXPORT_SUCCESS:
            return {
                ...state,
                isSuccess: true,
                hasError: false,
                isLoading: false,
                export: payload
            };
        case ActionTypes.EXPORT_FAILURE:
            return {
                ...state,
                hasError: true,
                isLoading: false
            };
        case ActionTypes.EXPORT_IS_LOADING:
            return {
                ...state,
                hasError: false,
                isLoading: true
            };
        default:
            return state;
    }
};
